/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Copy_To_AInputs */



/**
* | output |
* | --- |
* | "Copy to A" |
*
* @param {Compare_Event_Groups_Copy_To_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_copy_to_a = /** @type {((inputs?: Compare_Event_Groups_Copy_To_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Copy_To_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier vers A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopie an A")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia su A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать в А")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar a A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制到 A")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Aにコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("A को कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar para A")
	return /** @type {LocalizedString} */ ("Copy to A")
});